export default "__VITE_ASSET__059021c0__"